"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var AutocompleteField =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(AutocompleteField, _React$Component);

  function AutocompleteField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, AutocompleteField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(AutocompleteField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getInputWithIcon", function () {
      return _react.default.createElement(_antd.Input, {
        suffix: _react.default.createElement(_antd.Icon, {
          type: "search"
        })
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInputKeyDown", function (evt) {
      var _this$props = _this.props,
          loadableAutocompleteStore = _this$props.loadableAutocompleteStore,
          isClearable = _this$props.isClearable;
      var isBackspace = evt.keyCode === 8;

      if (isBackspace && isClearable) {
        loadableAutocompleteStore.resetAutocompleteState();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(AutocompleteField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var store = this.props.loadableAutocompleteStore;
      var _this$props2 = this.props,
          rcForm = _this$props2.rcForm,
          fieldId = _this$props2.fieldId,
          placeholder = _this$props2.placeholder,
          hasSearchIcon = _this$props2.hasSearchIcon;
      var props = {
        placeholder: placeholder,
        allowClear: true,
        className: this.getAutoCompleteClassNames(),
        onSearch: store.onChange,
        onSelect: store.onSelect,
        getSelectedOption: function getSelectedOption() {
          return store.getSelectedOption();
        },
        onInputKeyDown: function onInputKeyDown(evt) {
          return _this2.onInputKeyDown(evt);
        },
        dataSource: this.renderOptions()
      };

      if (rcForm) {
        return rcForm.getFieldDecorator(fieldId)(_react.default.createElement(_antd.AutoComplete, props, hasSearchIcon && this.getInputWithIcon()));
      }

      return _react.default.createElement(_antd.AutoComplete, (0, _extends2.default)({
        value: store.state.input
      }, props), hasSearchIcon && this.getInputWithIcon());
    }
  }, {
    key: "getAutoCompleteClassNames",
    value: function getAutoCompleteClassNames() {
      var base = 'loadable-autocomplete';

      if (typeof this.props.getAutocompleteFieldNames === 'function') {
        var state = this.props.loadableAutocompleteStore.state;
        var moreNames = this.props.getAutocompleteFieldNames(state);
        return "".concat(base, " ").concat(moreNames);
      }

      return base;
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this3 = this;

      return this.getOptions().map(function (option) {
        var optionVal = _this3.getOneOptionKeyValue(option);

        return _react.default.createElement(_antd.AutoComplete.Option, {
          key: "k-".concat(optionVal),
          value: optionVal
        }, typeof _this3.props.getOptionLabel === 'function' ? _this3.props.getOptionLabel(option) : option[_this3.props.optionDisplayNameKey]);
      });
    }
  }, {
    key: "getOneOptionKeyValue",
    value: function getOneOptionKeyValue(option) {
      var optionIdName = this.props.optionIdName;
      var optionKeyValue = option[optionIdName];
      var isStr = typeof optionKeyValue === 'string';
      return isStr ? optionKeyValue : optionKeyValue.toString();
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _this$props3 = this.props,
          isClearable = _this$props3.isClearable,
          loadableAutocompleteStore = _this$props3.loadableAutocompleteStore;
      var options = loadableAutocompleteStore.state.options;

      if (options.length > 70 && !isClearable) {
        return options.slice(0, 70);
      }

      if (options.length > 400 && isClearable) {
        return options.slice(0, 401);
      }

      return options;
    }
  }]);
  return AutocompleteField;
}(_react.default.Component);

exports.default = AutocompleteField;
AutocompleteField.propTypes = {
  // Required props
  loadableAutocompleteStore: _propTypes.default.object.isRequired,
  optionIdName: _propTypes.default.string.isRequired,
  optionDisplayNameKey: _propTypes.default.string.isRequired,
  // Optional props
  getOptionLabel: _propTypes.default.func,
  getAutocompleteFieldNames: _propTypes.default.func,
  rcForm: _propTypes.default.object,
  // Default props
  fieldId: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  hasSearchIcon: _propTypes.default.bool,
  isClearable: _propTypes.default.bool
};